import { render, staticRenderFns } from "./ReportDash.vue?vue&type=template&id=c8153720&scoped=true&"
import script from "./ReportDash.vue?vue&type=script&lang=js&"
export * from "./ReportDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8153720",
  null
  
)

export default component.exports